import React from "react";
import Loader from "../../../../components/Loader";
import "./ganttchart.scss";
import { useGanttChartState } from "./hooks/useGanttChartState";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";


const GantChartTimeline = () => {
  const [milestone] = useCustomSearchParams("milestone");

  const {
    calculateTaskPosition,
    isLoading,
    maxVisibleDays,
    minDate,
    totalDays,
    userGroups,
  } = useGanttChartState();

if(totalDays === 0){
  return <div className="loader-center">No data found</div>
}
  return (
    <>
      {isLoading ? (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      ) : (
        <div
         className={`gantt-chart-container ${
           milestone ? "gantt-chart-container--milestone" : "gantt-chart-container--default"
         }`}
         style={{ "--visible-days": maxVisibleDays }}
        >          <table className={`gantt-table ${totalDays > maxVisibleDays ? 'fixed-table-layout' : ''}`}>
            <thead>
              <tr>
                <th className="user-label-header">User Name</th>
                {Array.from({ length: totalDays }).map((_, index) => {
                  const date = new Date(minDate);
                  date.setDate(date.getDate() + index);
                  return (
                    <th key={`date-${index}`} className="date-column">
                      {date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {userGroups.map((group, groupIndex) => (
                <tr key={`user-${groupIndex}`} className="user-row">
                  <td className="user-label">{group.userName}</td>
                  <td colSpan={totalDays} className="tasks-cell">
                    <div className="tasks-container">
                      {group.tasks.map((task, taskIndex) => {
                        const style = calculateTaskPosition(task, taskIndex);
                        return (
                          <div 
                            key={`task-${taskIndex}`} 
                            className="task-bar"
                            style={style}
                            title={`${task.title} (${new Date(task.start_date).toLocaleDateString()} - ${new Date(task.end_date).toLocaleDateString()})`}
                          >
                            <div className="task-title">{task.title}</div>
                          </div>
                        );
                      })}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default GantChartTimeline;
